<div *ngIf="data?.length" class="vm-markdown" [innerHTML]="data | markdown"></div>